import { render, staticRenderFns } from "./ServiceCall.vue?vue&type=template&id=ce79b910&"
import script from "./ServiceCall.vue?vue&type=script&lang=js&"
export * from "./ServiceCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports